
// Constants for device states
export const DEVICE_STATES2 = {
    UNKNOWN: -1, //
    FIRST_INSTALL: 0, // a.k.a New. If a biometric device is stuck in this state it's not functioning.
    ONLINE_ICMP: 1,
    ONLINE_APP: 2,
    OFFLINE: 3,
    BUSY: 4,
    UPLOADING: 5,
    UNLICENSED: 6,
    DISABLED: 7,
    EMERGENCY_MODE: 8, // stateDetail: ON / OFF
    LOCKDOWN_MODE: 9, // stateDetail: ON / OFF
    USER_ID_LIST: 10,
    HARDWARE_STATE: 11, // Relays / Inputs / DIP switches.
    PERIPHERAL_STATE: 12, // Online devices attached to this device. E.g. list of terminal addressess detected.
    FIRMWARE_VERSION: 13, // Firmware version was queried.
    QUEUE_STATE: 14, // Queue count
    OTHER: 99, // Will be removed once all backend refactoring is complete. Till then it's a catch-all.
}

// Constants for COMMS_DIAGNOSTIC values stored against a device in the database.
export const COMMS_STATES = {
    OFFLINE: 0,
    ONLINE_ICMP: 1,
    UNKNOWN: 2,
    FIRST_INSTALL: 3,
    ONLINE_APP: 4
}

export const LockerStatus = {
    Available: {
        id: "1",
        label: "Available",
        translationKey: "available"
    },
    InUse: {
        id: "2",
        label: "In Use",
        translationKey: "inUse"
    }
}

// Labels for status legends
export default {
    Unknown: {
        id: "0",
        label: 'Unknown',
        translationKey: 'unknown'
    },
    Offline: {
        id: "1",
        label: 'Offline',
        translationKey: 'offline'
    },
    Online: {
        id: "2",
        label: 'Online',
        translationKey: 'online'
    },
    Disabled: {
        id: "3",
        label: 'Disabled',
        translationKey: 'disabled'
    },
    Unlicensed: {
        id: "4",
        label: 'Unlicensed',
        translationKey: 'unlicensed'
    },
    BusyUploading: {
        id: "5",
        label: 'Busy/Uploading',
        translationKey: 'busyUploading'
    }
};
